import type { RouteRecordRaw } from 'vue-router';

export const promotionBannerRoutes = {
  name: 'promotion-banner',
  path: 'promotion-banner',
  component: () => import('./PromotionBanner.vue'),
  // Fullscreen toggle + PIN-gated exit are owned by MainLayout (mirrors spin-customer): the layout
  // renders the `.fullscreen-toggle` chrome off this meta and hands the exit to the shared
  // `requirePin` gate, so the page never rebuilds them. `promotion_banner` is a contract action
  // name (`CashierPinAction`) — cùng ngôn ngữ với BE, không phải chuỗi tự đặt.
  // `kiosk` (TASK-207): màn đặt trước khách — lỗi nạp tiệm ⇒ màn chờ, không shell.
  meta: { kiosk: true, fullscreen: { requirePin: true, pinAction: 'promotion_banner' } },
} satisfies RouteRecordRaw;
